import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AlcmeonCardFooter } from 'src/app/shared/components/card-footer/models/alcmeon-card-footer.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import { CustomEvent } from '../custom-event.model';
import { CustomEventsService } from '../custom-events.service';
import { CustomEventTypeEnum } from '../shared/custom-event-type.enum';

@Component({
  selector: 'app-custom-event',
  templateUrl: './custom-event.component.html',
  styleUrls: ['./custom-event.component.scss'],
})
export class CustomEventComponent implements OnDestroy {
  create: boolean = this.customRouter.current.data?.create;
  customEvent: CustomEvent;
  subscriptions: Subscription = new Subscription();

  form: FormGroup = this.formBuilder.group({
    id: [null],
    name: ['', Validators.required],
    description: [null],
    type: [{ value: CustomEventTypeEnum.CUSTOM, disabled: true }],
  });
  customEventTypes = Object.values(CustomEventTypeEnum).map(id => ({
    id,
    label: this.basicService.translate(`parameters/custom-events/type/${id}`),
  }));
  backToLabel = this.basicService.translate('parameters/custom-events/details/back');
  footerContent: AlcmeonCardFooter;

  constructor(
    private formBuilder: FormBuilder,
    private customRouter: CustomRouter,
    private alcmeonContextService: AlcmeonContextService,
    private basicService: BasicService,
    private customEventsService: CustomEventsService
  ) {
    if (!this.create) {
      const { customEventId } = customRouter.params;
      this.customEventsService.getCustomEvent(customEventId).subscribe({
        next: (customEvent: CustomEvent) => {
          this.customEvent = customEvent;
          const { id, name, description, event_type } = customEvent;
          this.form.patchValue({ id, name, description, type: event_type });
          if (event_type !== CustomEventTypeEnum.CUSTOM) {
            this.form.disable();
          }
          const { updated_by, created_by, updated_at, created_at } = customEvent;
          const defaultLabel = this.basicService.translate('admin/users/is_admin');
          const getColleagueName = (id: number) =>
            this.alcmeonContextService.getColleague(id)?.realname ?? defaultLabel;
          this.footerContent = {
            createdBy: getColleagueName(created_by),
            createdAt: created_at,
            modifiedBy: getColleagueName(updated_by),
            modifiedAt: updated_at,
          };
        },
      });
    }
  }

  goBack() {
    this.customRouter.go('auth.alcmeon.fuse.parameters.custom-events.search');
  }

  save() {
    this.customEventsService.saveCustomEvent(this.form.value).subscribe({
      next: () => {
        this.basicService.translate('parameters/custom-events/details/saved');
        this.goBack();
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
